import React from 'react';
import '../index.css';

const AffiliateDisclosure = () => {
  return (
    <div className="container" style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px' }}>
      <div style={{ 
        textAlign: 'center', 
        marginBottom: '50px',
        animation: 'fadeInUp 0.6s ease-out'
      }}>
        <h1 style={{
          color: 'var(--text-accent)',
          fontSize: '42px',
          fontWeight: '800',
          marginBottom: '16px',
          textTransform: 'uppercase',
          letterSpacing: '2px'
        }}>
          Affiliate Disclosure
        </h1>
        <p style={{
          color: 'var(--text-secondary)',
          fontSize: '16px',
          lineHeight: '1.6'
        }}>
          Transparency in how we earn revenue
        </p>
      </div>

      <div style={{
        backgroundColor: 'var(--card-bg)',
        borderRadius: '16px',
        padding: '40px',
        border: '1px solid var(--border)',
        lineHeight: '1.8',
        fontSize: '16px',
        animation: 'fadeInUp 0.8s ease-out'
      }}>
        
        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            What This Means
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            GamersUnion participates in affiliate programs to help support the platform and keep it running. When 
            you click on certain links on our site and make a purchase, we may earn a small commission at no extra 
            cost to you. This helps cover hosting, development, and operational costs while keeping GamersUnion free 
            for the community.
          </p>
          <p style={{ color: 'var(--text)', marginBottom: '16px', fontWeight: '600', fontSize: '18px' }}>
            As an Amazon Associate I earn from qualifying purchases.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Where You'll Find Affiliate Links
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Affiliate links may appear in various places on GamersUnion, including:
          </p>
          <ul style={{ color: 'var(--text)', marginLeft: '24px', marginBottom: '16px' }}>
            <li style={{ marginBottom: '8px' }}>Game showcase pages linking to Steam, Amazon, or other game stores</li>
            <li style={{ marginBottom: '8px' }}>Discount offers and promotional codes for gaming products</li>
            <li style={{ marginBottom: '8px' }}>Blog posts and articles discussing gaming hardware or software</li>
            <li style={{ marginBottom: '8px' }}>Recommendations for gaming gear, accessories, or related products</li>
            <li style={{ marginBottom: '8px' }}>Links to indie game pages on platforms like itch.io or Steam</li>
          </ul>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Not every link is an affiliate link. We only use affiliate links where appropriate and when they 
            genuinely add value to the community.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Our Commitment to Honesty
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            We're upfront about our affiliate relationships because trust matters. Here's what you should know:
          </p>
          <ul style={{ color: 'var(--text)', marginLeft: '24px', marginBottom: '16px' }}>
            <li style={{ marginBottom: '8px' }}>
              <strong>No Influence on Reviews:</strong> Whether a game has an affiliate link or not doesn't affect 
              how we feature it or allow it to be reviewed. User reviews and ratings remain completely honest and unbiased.
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Quality First:</strong> We only showcase games and products we believe the community will find 
              valuable. Affiliate commissions don't change what gets featured on GamersUnion.
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>No Hidden Costs:</strong> Using our affiliate links never costs you extra. The price you pay 
              is the same whether you use our link or go directly to the store.
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Your Choice:</strong> You're never obligated to use our affiliate links. Feel free to search 
              for products directly if you prefer.
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Affiliate Programs We Participate In
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            GamersUnion currently participates in the following affiliate programs:
          </p>
          
          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ 
              color: 'var(--primary)', 
              fontSize: '20px', 
              fontWeight: '600',
              marginBottom: '12px'
            }}>
              Amazon Associates Program
            </h3>
            <p style={{ color: 'var(--text)', marginBottom: '12px' }}>
              We are a participant in the Amazon Services LLC Associates Program, an affiliate advertising program 
              designed to provide a means for sites to earn advertising fees by advertising and linking to Amazon.com 
              and affiliated sites. When you purchase products through our Amazon links, we earn a small commission.
            </p>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ 
              color: 'var(--primary)', 
              fontSize: '20px', 
              fontWeight: '600',
              marginBottom: '12px'
            }}>
              Game Platform Partnerships
            </h3>
            <p style={{ color: 'var(--text)', marginBottom: '12px' }}>
              We may participate in affiliate programs with gaming platforms such as Steam, Humble Bundle, GOG, and 
              others. When you purchase games through these links, we may earn a commission that helps support the platform.
            </p>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ 
              color: 'var(--primary)', 
              fontSize: '20px', 
              fontWeight: '600',
              marginBottom: '12px'
            }}>
              Other Partnerships
            </h3>
            <p style={{ color: 'var(--text)', marginBottom: '12px' }}>
              From time to time, we may partner with gaming hardware manufacturers, software companies, or other 
              gaming-related services. These partnerships help us keep GamersUnion running while providing value 
              to our community.
            </p>
          </div>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Why We Use Affiliate Links
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Running a community platform takes time and resources. Server costs, database hosting, email services, 
            content delivery networks, and ongoing development all require funding. Affiliate commissions help offset 
            these costs and allow me to keep building features the community asks for without charging membership fees 
            or plastering the site with intrusive ads.
          </p>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            By using our affiliate links, you're directly supporting GamersUnion's growth and helping us maintain 
            an independent, community-focused platform. Every small commission makes a difference.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Questions About Specific Links
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            If you ever want to know whether a specific link is an affiliate link, or if you have questions about 
            our affiliate relationships, feel free to reach out through our contact page or on Twitter at @AlonelyCat31. 
            We're happy to be transparent about any partnership or link on the platform.
          </p>
        </section>

        <section>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Thank You
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            Thank you for supporting GamersUnion by using our affiliate links when making purchases. Your support 
            helps keep this platform free, independent, and focused on what matters most: building a great community 
            for gamers and indie developers.
          </p>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            If you'd like to support us directly, you can make a donation at{' '}
            <a 
              href="https://razorpay.me/@alonelycat" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: 'var(--primary)', textDecoration: 'underline' }}
            >
              razorpay.me/@alonelycat
            </a>.
          </p>
        </section>

      </div>
    </div>
  );
};

export default AffiliateDisclosure;
